/**
 * navigation/useActiveView.ts
 * Current app route for the sidebar's active-item highlight, read from the
 * container ref (the sidebar lives outside the navigator). Sub-screens roll up
 * to their parent nav entry, mirroring the old AppContext PARENT map.
 */

import { useEffect, useState } from 'react';
import { navigationRef } from './navigationRef';
import type { AppRouteName } from './types';

// templateDetail is a drill-down from the Templates list (SKNOTIFICATION-
// GLOBAL-CR-001) — it should still highlight "Templates" in the sidebar.
const PARENT: Partial<Record<AppRouteName, AppRouteName>> = {
  templateDetail: 'templates',
};

export function useActiveView(): AppRouteName {
  const [active, setActive] = useState<AppRouteName>('log');

  useEffect(() => {
    const sync = () => {
      const current = navigationRef.isReady() ? navigationRef.getCurrentRoute() : undefined;
      if (!current) return;
      const name = current.name as AppRouteName;
      setActive(PARENT[name] ?? name);
    };
    sync();
    const unsubscribe = navigationRef.addListener('state', sync);
    return unsubscribe;
  }, []);

  return active;
}
